
import { Injectable } from '@angular/core';
import moment from 'moment';
import { MastersService } from '../services/masters/masters.service';
import { ToasterService } from '@ui-nuvertos/auth';

/**
 * Utility functions for PostingDate/PostingPeriod field interaction
 */
export class FiscalPeriodUtils {
  
  /**
   * Fetches fiscal period based on posting date and subsidiary
   * Shows toaster error if not found
   */
  static fetchFiscalPeriodByDate(
    mastersService: MastersService,
    toasterService: ToasterService,
    subsidiaryId: number | string,
    postingDate: Date | string,
    onSuccess: (fiscalPeriod: any) => void,
    onError?: () => void
  ): void {
    if (!postingDate) {
        return;
    }
    // Format date as YYYY-MM-DD
    const dateStr = moment(postingDate).format('YYYY-MM-DD');
    
    mastersService.getFiscalPeriodByDate(subsidiaryId, dateStr).subscribe({
      next: (response: any) => {
        if (response?.data) {
             onSuccess(response.data);
        } else if (response?.fiscal_period) {
             onSuccess(response.fiscal_period);
        } else {
             // Depending on API structure, it might return data directly or wrapped
             // Assuming structure from controller: SuccessResponse(..., resp)
             // Check if response itself is the object if not wrapped in data
             if (response.id && response.period_name) {
                 onSuccess(response);
             } else {
                 toasterService.error('No fiscal period found for the selected date');
                 onError?.();
             }
        }
      },
      error: (err: any) => {
        const errorMsg = err.error?.message || err.message || 'Failed to fetch fiscal period';
        toasterService.error(errorMsg);
        onError?.();
      }
    });
  }
}
